export default "__VITE_ASSET__HWCJk4$2__"